import React from 'react';
import { Link } from 'react-router-dom';

function OnConstruction() {
  return (
    <div className="on-construction">
      <img src="/images/on_construction.png" alt="Coming Soon" />
      <h2>⚠️ Em construção... </h2>
    </div>
  );
}

export default OnConstruction;